import { useFramerateProfilesApi } from "../../../common/api/orders-api/framerate-profile/useFramerateProfilesApi";

export const useAdminFramerateProfilesApi = () => {
    const { createFramerateProfile, getFramerateProfileList, updateFramerateProfile } = useFramerateProfilesApi();

    return {
        createFramerateProfile,
        getFramerateProfileList,
        updateFramerateProfile
    };
};
